export enum AssignmentCellMode {
  NotStarted,
  Missing,
  Ungraded,
  Graded,
  Started,
}
